module.exports = __webpack_public_path__ + "HP_Latex_630_Side.png?6c25ae2b10cd5bf3cee0ec442290d536";